import { useEffect, useState } from "react";
import { DEFAULT_SLIDES_PER_VIEW } from "../Carousel";
import { useBreakpoints } from "../../../../hooks/useBreakpoint";

const parseToArray = (el: number[] | number, length: number) =>
    Array.isArray(el) ? el : (Array.from({ length }).fill(el as number) as number[]);

export const useSlidesPerView = (unparsedSlidesPerView: number[] | number) => {
    const [slidesPerView, setSlidesPerView] = useState<number>(DEFAULT_SLIDES_PER_VIEW);
    const { base, md, lg, xl } = useBreakpoints(["base", "md", "lg", "xl"]);

    const parsedSlidesPerViewValue = parseToArray(
        unparsedSlidesPerView,
        (unparsedSlidesPerView as number[])?.length || 3
    );

    useEffect(() => {
        if (base) {
            setSlidesPerView(parsedSlidesPerViewValue[0]);
        }
        if (md) {
            setSlidesPerView(parsedSlidesPerViewValue[1] ?? parsedSlidesPerViewValue[0]);
        }
        if (lg) {
            setSlidesPerView(parsedSlidesPerViewValue[2] ?? parsedSlidesPerViewValue[0]);
        }
        if (xl) {
            setSlidesPerView(
                parsedSlidesPerViewValue[3] ??
                    parsedSlidesPerViewValue[2] ??
                    parsedSlidesPerViewValue[0]
            );
        }
    }, [base, md, lg, xl, parsedSlidesPerViewValue]);

    return { slidesPerView };
};
